import React, { createContext, useContext, useState } from 'react';
import useModalState from '../hooks/useModalState';
import useFileActions from '../hooks/useFileActions';
import useMenuOptions from '../hooks/useMenuOptions';
import useDocumentCreation from '../hooks/useDocumentCreation';

const FileOperationsContext = createContext();

export const useFileOperationsContext = () => {
  const context = useContext(FileOperationsContext);
  if (!context) {
    throw new Error('useFileOperationsContext must be used within a FileOperationsProvider');
  }
  return context;
};

export const FileOperationsProvider = ({ children }) => {
  const [templateUpdateTrigger, setTemplateUpdateTrigger] = useState(false);

  // Modal state management
  const { state: modalState, openModal, closeModal } = useModalState();

  // File action handlers
  const {
    handleDuplicate,
    handleMoveFile,
    handleMoveFolder,
    handleCopyFile,
    handleDeleteFile,
    handleDeleteFolder,
    handleRenameFile,
    handleRenameFolder,
  } = useFileActions(closeModal);

  // Menu option generators
  const { getFolderOptionContent, getFileOptionContent, getPlusButtonContent } = useMenuOptions(
    openModal,
    handleDuplicate,
    setTemplateUpdateTrigger
  );

  // Document creation
  const { openCreateDocument } = useDocumentCreation();

  const value = {
    // Modal state
    modalState,
    openModal,
    closeModal,

    // Template state
    templateUpdateTrigger,
    setTemplateUpdateTrigger,

    // File actions
    handleDuplicate,
    handleMoveFile,
    handleMoveFolder,
    handleCopyFile,
    handleDeleteFile,
    handleDeleteFolder,
    handleRenameFile,
    handleRenameFolder,

    // Menu options
    getFolderOptionContent,
    getFileOptionContent,
    getPlusButtonContent,

    // Document creation
    openCreateDocument,
  };

  return <FileOperationsContext.Provider value={value}>{children}</FileOperationsContext.Provider>;
};
